module.exports = __webpack_public_path__ + "static/media/branding@2x.20e4c3d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/branding@2x.jpg
// module id = 82
// module chunks = 0